import { render, staticRenderFns } from "./selectCampana.vue?vue&type=template&id=6bf60e07"
import script from "./selectCampana.vue?vue&type=script&lang=ts"
export * from "./selectCampana.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports